<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  .logo{
    display: grid;
    height: 25px;
    align-items: center;
  }
  .header{
    background-color:#2A2D2D;
    padding: 5px 20px;
    overflow: hidden;
    border-bottom:1px solid #202124;
  }
  .footer{
    width:100%;
    position:fixed;
    bottom:0px;
    left:0px;
    text-align:center;
    margin-bottom:-6px;
  }
  .footer p{
    line-height:30px;
    position:absolute;
    bottom:0;
    width:100%;
  }
  .container{
    width:1000px;
    margin:0px auto;
    padding:10px 0px;
    overflow: hidden;
  }

  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .bd{
    border:1px solid #f00;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue